<template>
  <b-container class="griddy">
    <b-row class="cstm-pl-15 cstm-pr-15">
      <b-col
        v-for="column in gridData"
        :key="column.gridId in gridData"
        class="columnDesktop d-none d-md-block"
      >
        <b-row class="hoverToFlip">
          <b-col v-if="column.imgFirst" cols="6" md="12">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[0]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
                <div class="flip-card-back">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[1]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="6" md="12">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front" :style="'background-color:#'+column.color[0]">
                  <p>
                    <span v-html="column.text[0]" />
                  </p>
                </div>
                <div class="flip-card-back" :style="'background-color:#'+column.color[1]">
                  <p>
                    <span v-html="column.text[1]" />
                  </p>
                </div>
              </div>
            </div>
          </b-col>
          <b-col v-if="!column.imgFirst" cols="6" md="12">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[0]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
                <div class="flip-card-back" style="background-color:#F05B2D;">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[1]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="columnMobile d-md-none">
        <b-row v-for="column in gridData" :key="column.gridId in gridData" class="rowMobile">
          <!-- <b-row class="hoverToFlip"> -->
          <b-col v-if="column.imgFirst" cols="6" md="12">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[0]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
                <div class="flip-card-back">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[1]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="6" md="12">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front" :style="'background-color:#'+column.color[0]">
                  <p>
                    <span v-html="column.text[0]" />
                  </p>
                </div>
                <div class="flip-card-back" :style="'background-color:#'+column.color[1]">
                  <p>
                    <span v-html="column.text[1]" />
                  </p>
                </div>
              </div>
            </div>
          </b-col>
          <b-col v-if="!column.imgFirst" cols="6" md="12">
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[0]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
                <div class="flip-card-back" style="background-color:#F05B2D;">
                  <b-img
                    class="logo"
                    :src="'/img/'+column.img[1]"
                    alt="MVP Logo"
                    style="width:100%;"
                  />
                </div>
              </div>
            </div>
          </b-col>
          <!-- </b-row> -->
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      gridData: [
        {
          imgFirst: true,
          color: ['FAAF43', 'F05B2D'],
          img: ['grid_img_1.jpg', 'grid2_img_1.jpg'],
          text: [
            "LIVE IN ONE OF<br>CANADA'S FASTEST<br>GROWING CITIES",
            '15 MINS TO<br>GEORGIAN COLLEGE'
          ]
        },
        {
          color: ['F05B2D', '35BFAD'],
          img: ['grid_img_2.jpg', 'grid2_img_2.jpg'],
          text: [
            '5 MINS TO<br>BEAUTIFUL<br>LAKE SIMCOE',
            '5 MINS TO<br>HWY. 400'
          ]
        },
        {
          imgFirst: true,
          color: ['35BFAD', '29AAE1'],
          img: ['grid_img_3.jpg', 'grid2_img_3.jpg'],
          text: [
            '3 MINS TO<br>SOUTH BARRIE<br>GO STATION',
            '45 MINS DRIVE<br>TO VAUGHAN<br>SUBWAY STATION'
          ]
        },
        {
          color: ['FAAF43', 'F05B2D'],
          img: ['grid_img_4.jpg', 'grid2_img_4.jpg'],
          text: [
            '90 MINS TO UNION STATION<br>ON GO TRAIN*',
            'SCHOOLS AND<br>PARKS NEARBY'
          ]
        },
        {
          imgFirst: true,
          color: ['29AAE1', '35BFAD'],
          img: ['grid_img_5.jpg', 'grid2_img_5.jpg'],
          text: [
            'A BUSTLING CITY<br>WITH SHOPS &amp;<br>RESTAURANTS MINS AWAY',
            'COMPLETE<br>COMMUNITY OF OVER<br>900 HOMES '
          ]
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.griddy {
  padding-left:20px;
  padding-right: 20px;
  .col {
    text-align: center;
  }
  p {
    margin: 0px;
    color: white;
  }
  .columnNextLine {
    width: 100%;
  }
  .col-md-12.col-6 {
    @media screen and (min-width: 768px) {
      height: 138px;
      img {
        height: 138px;
      }
    }
    @media screen and (min-width: 1000px) {
      height: 186px;
      img {
        height: 186px;
      }
    }
    @media screen and (min-width: 1200px) {
      height: 222px;
      img {
        height: 222px;
      }
    }
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.columnMobile {
  .rowMobile {
    height: 255px;
    @media screen and (max-width: 540px) {
      height: calc(50vw - 15px);
    }
  }
  .flip-card-inner {
    animation: flip 10s infinite ease-in-out;
  }
}
.columnDesktop {
  .hoverToFlip:hover .flip-card-inner {
    transform: rotateY(180deg);
  }
}
@keyframes flip {
  0% {
    transform: rotateY(0deg);
  }
  20% {
    transform: rotateY(0deg);
  }
  30% {
    transform: rotateY(180deg);
  }
  60% {
    transform: rotateY(180deg);
  }
  70% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(0deg);
  }
}
.flip-card {
  .flip-card-inner {
    .flip-card-front,
    .flip-card-back {
      padding: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.flip-card {
  background-color: transparent;
  width: 100%;
  height: 100%;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.flip-card-front {
  // background-color: #bbb;
  color: black;
}

.flip-card-back {
  // background-color: #2980b9;
  color: white;
  transform: rotateY(180deg);
}
</style>
